





























import {
    Component,
    Prop,
    Vue,
} from 'vue-property-decorator';
import {
    State,
    Mutation,
    namespace,
} from 'vuex-class';
const userModule = namespace('user');

@Component({})
export default class HeaderUser extends Vue {

    private menuCommand: any = {
        logout:  this.logout,
    };

    private handleCommand(e: any) {
        this.menuCommand[e.key]();
    }

    @userModule.Mutation('loginSuccess')
    private loginSuccess(param: any) {

    }

    /**
     * 退出登录，需要做其他事情
     */
    private logout() {
        this.$ls.remove('token');
        this.loginSuccess({token: null});
        this.$router.push('/passport/login');
    }
}
